<template>
  <div
    class="solfigrf-icmtournament-sctuctire solfigricmttr"
    :class="[{ gw_loading: loading }]"
  >
    <ExpandCard
      :opened="false"
      persistKey="solfigr_solfigricmplstcks"
      style="
        --clr-back-title: var(--clr-black-2);
        --clr-back-title-hover: var(--clr-black-2-3);
        --clr-back-title-active: var(--clr-black-2);
        --title-color: var(--clr-white-0);
        --content-padding: 0;
        --max-height: var(--vh-3);
        --radius: 4px;
        --radius-title: 4px 4px 0 0;
        --radius-content: 0 0 4px 4px;
        --open-overflow: unset;
        --overflow-content-open-y: unset;
        --overflow-content-open-x: unset;
      "
      data-tst="solfigr_solfigricmplstcks"
    >
      <template #title>
        <div
          class="flex-1 d-flex"
          style="min-width: 0"
        >
          <div class="mdi mr-2 mdi-check-circle clr-primary"></div>
          {{ $t(`solfigr.icm.players_and_stacks`) }}
        </div>
      </template>

      <template #default="{ open }">
        <SolfigrIcmOtherStacks
          style="border: solid 2px var(--clr-black-2); border-top: none; padding: 0.5rem"
          :namespace
          :loading
          :icmPlayersAndStacks
          :hasBountyAvg
          :hasStacksTable="open"
          v-bind="$attrs"
        />
      </template>
    </ExpandCard>
  </div>
</template>

<script>
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'
import float_mix from '@/mixins/float_mix'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import SolfigrIcmOtherStacks from '@/components/ConfigureSolution/SolfigrIcmOtherStacks'

export default {
  name: 'SolfigrIcmOtherStacksExpand',
  components: {
    ExpandCard,
    SolfigrIcmOtherStacks,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    loading: Boolean,
    icmPlayersAndStacks: Object,
    hasBountyAvg: Boolean,
  },
  data() {
    this.conf = getSolfigrFields()
    return {}
  },
}
</script>
